// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-StudyList-MergeStudiesDialog-MergeStudiesDialog-module__errorMessage";
var _2 = "webpack-pages-StudyList-MergeStudiesDialog-MergeStudiesDialog-module__modalFooterSpacer";
var _3 = "webpack-pages-StudyList-MergeStudiesDialog-MergeStudiesDialog-module__studyOption";
var _4 = "webpack-pages-StudyList-MergeStudiesDialog-MergeStudiesDialog-module__studyTitle";
export { _1 as "errorMessage", _2 as "modalFooterSpacer", _3 as "studyOption", _4 as "studyTitle" }
